import { makeAutoObservable, runInAction } from 'mobx';
import { AutoParFilters, AutoParRecord, FrequencySelection } from '../types/autopar';

export class AutoParStore {
  records: AutoParRecord[] = [];
  totalCount = 0;
  loading = false;

  filters: AutoParFilters = {
    manuIds: [],
    prodTypeIds: [],
    colIds: [
      'Manufacturer',
      'ProdType',
      'CatNum',
      'Brand',
      'Desc',
      'Usage',
      'Qty',
      'OnOrder',
      'Par',
      'Freq',
      'MaxUsage',
      'Suggested',
      'LastUsed',
      'Actions',
    ],
    frequencySelection: '0',
    frequency: 0,
    reservePercent: 20,
    sortColumn: 0,
    sortOrder: 0,
    currentPage: 1,
    rowsPerPage: 100,
  };

  constructor() {
    makeAutoObservable(this);
  }

  setFrequencySelection(fs: FrequencySelection) {
    this.filters.frequencySelection = fs;
  }

  setFrequency(value: number) {
    this.filters.frequency = value;
  }

  setReservePercent(value: number) {
    this.filters.reservePercent = value;
  }

  setSort(column: number, order: 0 | 1) {
    this.filters.sortColumn = column;
    this.filters.sortOrder = order;
  }

  setColumns(colIds: string[]) {
    this.filters.colIds = colIds;
  }

  setFilters(partial: Partial<AutoParFilters>) {
    this.filters = { ...this.filters, ...partial };
  }

  setPage(page: number) {
    this.filters.currentPage = page;
  }

  async load() {
    this.loading = true;
    try {
      // Mock data until backend is ready
      const mock = [
        {
          productType: 'Sutures',
          manufacturerId: 101,
          manufacturerName: 'Acme Medical',
          brandName: 'Acme Ultra',
          description: 'Absorbable suture 3-0',
          catalogNo: 'ACM-300',
          parLevel: 50,
          usagePerMonth: 120,
          ordersPerMonth: 4,
          maxMonthUsage: 180,
          quantity: 75,
          quantityOnOrder: 10,
          lastUsedDate: '2025-10-10',
        },
        {
          productType: 'Bandages',
          manufacturerId: 102,
          manufacturerName: 'Medico',
          brandName: 'Medico Flex',
          description: 'Elastic bandage 4in',
          catalogNo: 'MED-EL4',
          parLevel: 30,
          usagePerMonth: 60,
          ordersPerMonth: 2,
          maxMonthUsage: 90,
          quantity: 40,
          quantityOnOrder: 5,
          lastUsedDate: '2025-12-01',
        },
        {
          productType: 'Gloves',
          manufacturerId: 103,
          manufacturerName: 'SafeHands',
          brandName: 'SafeHands Nitrile',
          description: 'Nitrile gloves M',
          catalogNo: 'SH-NM',
          parLevel: 200,
          usagePerMonth: 500,
          ordersPerMonth: 8,
          maxMonthUsage: 800,
          quantity: 250,
          quantityOnOrder: 50,
          lastUsedDate: '2026-01-01',
        },
      ];
      runInAction(() => {
        this.records = mock;
        this.totalCount = mock.length;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}

export const autoParStore = new AutoParStore();
